import { useTranslation } from 'react-i18next'

import LangLink from '../components/LangLink'
import Section from '../components/Section'

interface Stat {
  value: string
  label: string
}

function PartnerChinaPage() {
  const { t } = useTranslation()
  const stats = t('partnerChina.stats', { returnObjects: true }) as Stat[]
  const branches = t('partnerChina.branches', { returnObjects: true }) as string[]

  return (
    <div className="partner-china-page">
      {/* ---------- header ---------- */}
      <Section background="surface" space="md" className="partner-china-hero">
        <p className="breadcrumb">
          <LangLink to="/partners">
            {t('partnerChina.breadcrumbParent')}
          </LangLink>{' '}
          / {t('partnerChina.breadcrumbCurrent')}
        </p>
        <h1 className="display">{t('partnerChina.title')}</h1>
        <p className="partner-china-lead">{t('partnerChina.intro')}</p>
      </Section>

      {/* ---------- at a glance (dark band): scale + infrastructure + address ---------- */}
      <Section background="dark" space="lg" className="partner-china-glance">
        <p className="eyebrow">{t('partnerChina.glanceEyebrow')}</p>
        <div className="stat-grid">
          {stats.map((s) => (
            <div key={s.label} className="stat">
              <span className="stat-value">{s.value}</span>
              <span className="stat-label">{s.label}</span>
            </div>
          ))}
        </div>
        <p className="partner-china-address">
          <span className="partner-china-address-label">
            {t('partnerChina.addressLabel')}
          </span>
          {t('partnerChina.address')}
        </p>
      </Section>

      <picture>
        <source srcSet="/partner/gate.webp" type="image/webp" />
        <img
          src="/partner/gate.jpg"
          alt={t('home.partner.imgAlt2')}
          className="partner-china-band-img"
          loading="lazy"
          width={1279}
          height={462}
        />
      </picture>

      {/* ---------- what they supply + logistics ---------- */}
      <Section background="beige" space="lg" className="partner-china-prose">
        <h2>{t('partnerChina.suppliesHeading')}</h2>
        <p>{t('partnerChina.supplies')}</p>
        <h2>{t('partnerChina.logisticsHeading')}</h2>
        <p>{t('partnerChina.logistics')}</p>
      </Section>

      <picture>
        <source srcSet="/partner/rack.webp" type="image/webp" />
        <img
          src="/partner/rack.jpg"
          alt={t('partnerChina.rackAlt')}
          className="partner-china-band-img"
          loading="lazy"
          width={1153}
          height={586}
        />
      </picture>

      {/* ---------- market presence + scale ---------- */}
      <Section background="surface" space="lg" className="partner-china-prose">
        <h2>{t('partnerChina.presenceHeading')}</h2>
        <p>{t('partnerChina.presenceIntro')}</p>
        <ul className="chip-list">
          {branches.map((b) => (
            <li key={b}>{b}</li>
          ))}
        </ul>
        <p>{t('partnerChina.presenceOutro')}</p>
        <h2>{t('partnerChina.scaleHeading')}</h2>
        <p>{t('partnerChina.scale')}</p>
      </Section>

      {/* ---------- shared values: motto as a pull quote ---------- */}
      <Section background="beige" space="md" className="partner-china-values">
        <p className="eyebrow">{t('partnerChina.valuesHeading')}</p>
        <blockquote className="partner-china-quote">
          <p>{t('partnerChina.motto')}</p>
        </blockquote>
        <p className="partner-china-values-body">
          {t('partnerChina.valuesBody')}
        </p>
      </Section>

      {/* ---------- quote CTA band ---------- */}
      <Section background="bordeaux" space="md" className="partner-china-cta">
        <h2>{t('home.quote.heading')}</h2>
        <p>{t('home.quote.body')}</p>
        <LangLink to="/how-to-order" className="btn btn--on-dark">
          {t('home.cta')}
        </LangLink>
      </Section>
    </div>
  )
}

export default PartnerChinaPage
